var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.55566H20",
    stroke: "#EF5E3B",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4445 6.55556V4.77778C8.4445 4.30628 8.6318 3.8541 8.9652 3.5207C9.2986 3.1873 9.75078 3 10.2223 3H13.7778C14.2493 3 14.7015 3.1873 15.0349 3.5207C15.3683 3.8541 15.5556 4.30628 15.5556 4.77778V6.55556M18.2223 6.55556V19C18.2223 19.4715 18.035 19.9237 17.7016 20.2571C17.3682 20.5905 16.916 20.7778 16.4445 20.7778H7.55561C7.08411 20.7778 6.63193 20.5905 6.29853 20.2571C5.96513 19.9237 5.77783 19.4715 5.77783 19V6.55556H18.2223Z",
    stroke: "#EF5E3B",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2222 11.0001V16.3335",
    stroke: "#EF5E3B",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7778 11.0001V16.3335",
    stroke: "#EF5E3B",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.82ce45f0c9bc79f47a488d459b93d5fb.svg";
export { ForwardRef as ReactComponent };